import React, { useState } from 'react';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { getFormattedDate, formatAmPm, calculateDuration } from 'helpers';
import { styled } from '@mui/material/styles';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 600,
  fontSize: 15,
  backgroundColor: theme.palette.grey[100],
  borderBottom: `2px solid ${theme.palette.primary.light}`,
  color: theme.palette.primary.dark,
  padding: '12px 16px',
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
    cursor: 'pointer',
  },
}));

const DriverDutyLogsTable = ({ driverDutyLogs, total_count = 0, onShowMore }) => {
  const [displayCount, setDisplayCount] = useState(4);

  if (!driverDutyLogs.length) return null;

  const handleShowMore = () => {
    setDisplayCount(prev => prev + 4);
    if (onShowMore) onShowMore(displayCount);
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ mt: 4, boxShadow: 3, borderRadius: 2, maxWidth: '100%', overflowX: 'auto' }}>
        <Table size="medium" sx={{ minWidth: 800 }}>
          <TableHead>
            <TableRow sx={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f5f5f5' }}>
              <StyledTableCell sx={{ width: '20%' }}>Driver Name</StyledTableCell>
              <StyledTableCell sx={{ width: '20%' }}>Date</StyledTableCell>
              <StyledTableCell sx={{ width: '20%' }}>Check-in Time</StyledTableCell>
              <StyledTableCell sx={{ width: '20%' }}>Check-out Time</StyledTableCell>
              <StyledTableCell sx={{ width: '20%' }}>Total Duration</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { driverDutyLogs.slice(0, displayCount).map((log, idx) => {
              const duration = calculateDuration(log.check_in_at, log.check_out_at);
              return (
                <StyledTableRow key={idx}>
                  <TableCell sx={{ fontWeight: 500, fontSize: 15, color: 'primary.main' }}>{log.user?.first_name} {log.user?.last_name}</TableCell>
                  <TableCell sx={{ fontSize: 14 }}>{log.check_in_at ? getFormattedDate(log.check_in_at) : '-'}</TableCell>
                  <TableCell sx={{ fontSize: 14 }}>{log.check_in_at ? formatAmPm(new Date(log.check_in_at)) : '-'}</TableCell>
                  <TableCell sx={{ fontSize: 14 }}>{log.check_out_at ? formatAmPm(new Date(log.check_out_at)) : '-'}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: 'success.main', fontSize: 15 }}>{duration ? `${duration.hours}h ${duration.minutes}m` : '-'}</TableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {driverDutyLogs.length < total_count && (
        <Button color='primary' variant='outlined' onClick={handleShowMore} sx={{ width: '50%', mt: 2, fontWeight: 600, letterSpacing: 1, fontSize: 16 }}>
          Show more
        </Button>
      )}
    </>
  );
};

export default DriverDutyLogsTable; 